export const EmptyState = ({ title, body, icon: Icon, cta }) => (
  <div className="zita-card p-10 text-center">
    {Icon && (
      <div className="w-14 h-14 rounded-full bg-zita-sand mx-auto flex items-center justify-center text-zita-cocoa mb-4">
        <Icon size={22} />
      </div>
    )}
    <h3 className="font-serif text-2xl text-zita-espresso">{title}</h3>
    <p className="mt-2 text-zita-mocha max-w-md mx-auto">{body}</p>
    {cta && <div className="mt-6">{cta}</div>}
  </div>
);
